t = require('views/internal/teacup-with-helpers')('create_first_board')

module.exports = t.renderable ->
  t.a '.first-board-logo.js-cancel', { href: "#" }, ->
    t.img { src: require 'images/trello-logo-blue.svg' }
  t.div '.first-board-columns', ->
    t.div '.first-board-column.first-board-image', ->
      t.div '.first-board-image-wrapper', ->
        t.img { src: require 'images/first-board-low-fidelity.svg' }
        t.p '.js-board-name-display'
    t.div '.first-board-column', ->
      t.div '.first-board-text', ->
        t.h2 ->
          t.format 'welcome-to-trello'
        t.p ->
          t.format 'you-can-organize-just-about-anything-with-a-trello-board'
          t.span '.show-point-right', ->
            t.format 'that-thing-over-there'
          t.span '.show-point-up', ->
            t.format 'that-thing-up-there'
        t.p ->
          t.format 'start-by-naming-your-board-something-related-to-the-project'
        t.input '.js-board-name.first-board-name-input', { placeholder: t.l('eg-vacation-planning'), required: true }
  t.button '.js-submit.first-board-footer',  { type: "submit" }, ->
    t.p ->
      t.format 'great-lets-build-your-board'
      t.icon 'up', { class: 'first-board-rotate' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/create_first_board.coffee